import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConstantService } from './constant.service';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
	requestCount: number = 0;
  permissionActiveEmitter = new Subject<any>();
	errorListEmitter = new Subject<any>();
	stickyMessageEmitter = new Subject<any>();

  constructor(
		private permissionService: PermissionService,
		private constantService: ConstantService) { }

  printLog(message: any, values?: any) {
		if (!environment.production) console.log(message, values);
	}

  setLocalStore(key: string, data: any) {
		localStorage.setItem(key, JSON.stringify(data));
	}

	getLocalStore(key: string) {
		let data: any = '';
		if (!!key && localStorage.getItem(key) !== undefined && localStorage.getItem(key) !== null) {
			let localData: any = localStorage.getItem(key);
			if (!!localData && localData !== 'undefined') {
				data = JSON.parse(localData);
			}
		}
		return data;
	}

	clearStorageFor(key: string) {
		return localStorage.removeItem(key);
	}

	clearStorage() {
		localStorage.clear();
	}

	getCountryCodeOfUser() {
		return "IND";
	}

	configHelpDesk(action = 'add', pageName = 'home') {
		let isFreshdeskAccess = false;
		if (action !== 'add') {
			isFreshdeskAccess = this.permissionService.checkSectionPermission('freshdesk');
		}
		var freshworksContainer: any = document.getElementById('freshworks-container');
		if (freshworksContainer !== undefined && freshworksContainer !== null) {
			if (isFreshdeskAccess === false || action === 'add') {
				freshworksContainer['style']['display'] = 'none';
			} else {
				freshworksContainer['style']['display'] = 'block';
			}
		}
	}

	countryCodes(country_code: any) {
		if (country_code == null) {
			return '';
		} else {
			//   if (this.constantService.countryConfigData[country_code]) {
			//     return this.constantService.countryConfigData[country_code].mobile_country_code;
			//   }
			return '+91'
		}
	}

	displayDateFormat(dateVal = null, convertFormat = 'DD-MMM-YYYY', dateFormat = 'YYYY-MM-DD') {
		if(!!dateVal) {
			const dateObj = moment(dateVal, dateFormat);
			let rDate = dateObj.format(convertFormat);
			return rDate;
		} else {
			return '';
		}
	}

	URLReplacer(str: string) {
		let match = str.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi);
		let final = str;
		match?.map((url) => {
			final = final.replace(url, '<a href="' + url + '" target="_BLANK">' + url + '</a>');
		});
		return final;
	}
	//allow only numeric input
	keyPressAlphanumeric(event: any) {
		var inp = String.fromCharCode(event.keyCode);
		if (/[0-9]/.test(inp)) {
			return true;
		} else {
			event.preventDefault();
			return false;
		}
	}
	getCurrentUserInfo(){
		var userInfo ;
		let isOnbehlaf = this.getLocalStore('isOnBehalf');
		if(isOnbehlaf){
			let onBehalfUserData = this.getLocalStore('onBehalfUserData');
			if(onBehalfUserData != null){
				userInfo = onBehalfUserData?.userInfo
			}
				
		}
		else{
			let aUser = this.getLocalStore('aUser'); 
			userInfo = aUser;
		}
		
		return userInfo
	}

	appendMandalType(Mandals: any) {
		Mandals.forEach((element: any, index: any) => {
			let location_type = element.location_type.split(' ');
			if (location_type[0] !== 'Mandal') {
				location_type[0] = ' (' + location_type[0] + ')';
			} else {
				location_type[0] = '';
			}
			Mandals[index].location_name = element.location_name + location_type[0];
		});
		return Mandals;
	}
}
